




























































helpers = require('../../helpers.coffee')

view_model = {
  components:
    draggable: require('vuedraggable')
    filters: require('./filters.vue')
    massActions: require('./mass_actions.vue')

  props:
    origem:
      default: null

    contacts:
      default: -> []

    selected_contact_ids:
      default: -> []

    unselected_contact_ids:
      default: -> []

    count_all_contacts:
      default: -> 0

    count_page_contacts:
      default: -> 0

    initially_selected_contact_ids:
      default: -> []

    view_mode:
      type: Object
      required: true

    flow:
      type: Flow
      default: null

    filters:
      default: -> {}

    internal_scroller:
      default: false

    draggable_options:
      default: -> { disabled: true, filter: '.undraggable' }

    user_id:
      default: null

  data: ->
    selected_all: false
    selected_page: false

  computed:
    add_action_column: ->
      @view_mode.actions_dropdown || @view_mode.anywhere_select_action == 'emit-selected'

  methods:
    removeContactFromList: (contact_id) ->
      @contacts.remove(contact_id)

    filter: (filters) ->
      @applyFiltersOnUrlQueryParams(filters) if @view_mode.change_url_on_filter
      @$emit('filter', filters)
      @trackIntercomContactsFilter()

    toggleSelectAll: ->
      @selected_all = ! @selected_all
      EventsBus.$emit 'ContactList:SelectedAll', { @selected_all }

    selectedAll: (data) ->
      @selected_all = data.selected_all if @view_mode.show_selections

    unSelectedAll: ->
      @selected_all = false

    selectedPage: (data) ->
      @selected_page = data.selected_page

    contactsEmpty: ->
      jQuery.isEmptyObject @contacts

    isInitiallySelected: (contact) ->
      return true if @selected_all
      @initially_selected_contact_ids.indexOf(contact.id) != -1

    hitBottom: ->
      return unless @internal_scroller
      @$emit 'hit-bottom'

    priorityUpdated: (contacts) ->
      @$emit('priority-updated', contacts)

    trackIntercomContactsFilter: ->
      origem = if @flow
        "Fluxo "
      else if location.href.match(/\/contatos/)
        "Base de contatos"
      else if location.href.match(/\/grupos-de-contatos\/\d+\/editar/)
        'Edição de grupo - Contatos'

      IntercomCtrl.trackEvent(origem + ' - Utilização da busca manual')

    infinitScrollTable: ->
      return unless @internal_scroller
      element = document.querySelector('.table-body.internal-scroller')
      return unless element

      element.addEventListener 'scroll', =>
        if element.scrollTop + element.clientHeight >= (element.scrollHeight - 100)
          @emitScrollEnded()

    emitScrollEnded: ->
      @$emit 'scroll-ended' if @internal_scroller

  created: ->
    EventsBus.$on 'ContactList:SelectedAll', @selectedAll
    EventsBus.$on 'ContactList:SelectedPage', @selectedPage
    EventsBus.$on 'ContactList:unSelectedAll', @unSelectedAll

  mounted: ->
    @infinitScrollTable()

  beforeDestroy: ->
    EventsBus.$off 'ContactList:SelectedAll', @selectedAll
    EventsBus.$off 'ContactList:SelectedPage', @selectedPage
    EventsBus.$off 'ContactList:unSelectedAll', @unSelectedAll
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/list.vue